import script from "./PageSectionNavigator.vue?vue&type=script&lang=ts&setup=true"
export * from "./PageSectionNavigator.vue?vue&type=script&lang=ts&setup=true"

import "./PageSectionNavigator.vue?vue&type=style&index=0&id=50a711c7&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50a711c7"]])

export default __exports__